import { Amplify } from 'aws-amplify';
import { Hub } from 'aws-amplify/utils';
import { getCurrentUser as amplifyGetCurrentUser, signInWithRedirect, signOut as amplifySignOut } from 'aws-amplify/auth';


let amplifyConfigured = false;


export async function loadAuthConfig() {
    // Prefer dynamic config.js (window.AUTH_CONFIG), fallback to /config.json
    if (typeof window !== 'undefined' && window.AUTH_CONFIG) {
        console.log("Load auth config from window: ", window.AUTH_CONFIG)
        return window.AUTH_CONFIG;
    }
    try {
        const res = await fetch('/config.json', { cache: 'no-store' });
        if (res.ok) {
            return await res.json();
        }
    } catch { }
    throw new Error('Missing auth config. Provide config.js (window.AUTH_CONFIG) or /config.json');
}


function normalizeDomain(domain) {
    if (!domain) return '';
    let d = String(domain).trim();
    if (d.startsWith('https://')) d = d.slice(8);
    if (d.startsWith('http://')) d = d.slice(7);
    if (d.endsWith('/')) d = d.slice(0, -1);
    return d;
}


export async function configureAmplify() {
    if (amplifyConfigured) return;


    const cfg = await loadAuthConfig();
    const region = cfg.region || 'eu-central-1';
    const oauth = cfg.oauth || {};


    const domain = normalizeDomain(oauth.domain || cfg.domain || cfg.oauthDomain);
    const redirectSignIn = Array.isArray(oauth.redirectSignIn)
        ? oauth.redirectSignIn
        : (oauth.redirectSignIn ? [oauth.redirectSignIn] : [window.location.origin + '/']);
    const redirectSignOut = Array.isArray(oauth.redirectSignOut)
        ? oauth.redirectSignOut
        : (oauth.redirectSignOut ? [oauth.redirectSignOut] : [window.location.origin + '/']);
    const scopes = oauth.scope || oauth.scopes || ['email', 'openid', 'profile'];
    const responseType = oauth.responseType || 'code';


    // Amplify v6 config shape
    Amplify.configure({
        Auth: {
            Cognito: {
                region,
                userPoolId: cfg.userPoolId,
                userPoolClientId: cfg.userPoolWebClientId,
                loginWith: {
                    oauth: {
                        domain,
                        scopes,
                        redirectSignIn,
                        redirectSignOut,
                        responseType
                    }
                }
            }
        }
    });


    amplifyConfigured = true;


    // Optional: listen for auth events
    Hub.listen('auth', ({ payload }) => {
        if (payload?.event) {
            console.debug('Auth event:', payload.event);
        }
    });
}


export async function getCurrentUser() {
    await configureAmplify();
    try {
        return await amplifyGetCurrentUser();
    } catch {
        return null;
    }
}


export async function signInWithHostedUi() {
    await configureAmplify();
    return signInWithRedirect(); // redirects to Hosted UI
}


export async function signOut() {
    await configureAmplify();
    return amplifySignOut({ global: true }); // redirects back per redirectSignOut
}